import { createFeatureSelector } from '@ngrx/store';

export const onlineOrderState = createFeatureSelector<OLO.State, OLO.State.OnlineOrder>('onlineOrder');
